var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"not-found"}},[_c('h1',[_vm._v("指定されたページは存在しません．")]),_c('p',{attrs:{"id":"home-route"},on:{"click":_vm.goHome}},[_c('u',[_vm._v("ホームへ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }